import { useAuth } from "../../../../context";
import { useMutation } from "react-query";
import { Product } from "../../../../api/supplier-questionnaire/product";

export function useCreateProduct(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(Product.createProduct, { questionnaireId, data }), config);
}

export function useUpdateProduct(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, id, data}) =>
    callApi(Product.updateProduct, { questionnaireId, id, data }), config);
}